import React, {useContext, useEffect, useRef, useState} from 'react';
import {PlayerContext, PlayerContextDispatch, Station as StationData, STYLESLOADED_ACTION} from "../PlayerReducer";
import {makeUUID} from "../utils";

type Song = {
    interpret: string,
    song: string,
    shortInterpret: string,
    shortSong: string
}



const makeCss = (left:number, uuid: string, key:number, second:number) => {
    const spin =`
                    0% { transform: translateX(${0}px); } 
                    45% { transform: translateX(${left}px); }
                    55% { transform: translateX(${left}px); } 
                    90% { transform: translateX(${0}px); }
                    100% { transform: translateX(${0}px); }
    `;
    const keyFrames = `
                    @keyframes radiacz-keyframe-${uuid}-${key} {
                        ${spin}
                    }
                    @-webkit-keyframes radiacz-keyframe-${uuid}-${key} {
                        ${spin}
                    }
                    .radiacz-running-text-${uuid}-${key} {
                        animation: radiacz-keyframe-${uuid}-${key} ${second}s infinite ease-in-out both;
                        -webkit-animation: radiacz-keyframe-${uuid}-${key} ${second}s infinite ease-in-out both;
                        
                    }
                    
                    `
    return keyFrames;
}

const isHidden = ()=>{
    switch (document.visibilityState)
    {
        case 'hidden':
            return true;
        case 'visible':
            return false;
        default:
            return undefined;
    }
}

const StationItem = (props: {
    station: StationData,
    styleLoaded: boolean
}) => {

    const {station} = props;
    const [song, setSong] = useState<Song | false>(false)
    const [uuid] = useState(makeUUID());
    const [divsCss, setDivsCss] = useState(
        ''
    );

    const [hidden, setHidden] = useState(()=>{
        return isHidden();
    });

    const setHiddenRef = useRef(setHidden);
    setHiddenRef.current = setHidden;

    const divs = useRef([
       null as HTMLDivElement|null,
       null as HTMLDivElement|null
    ]);

    const newWindow = useRef<HTMLAnchorElement|null>(null)

    const refInterval = useRef<ReturnType<typeof setInterval>>();
    const unmountedRef = useRef<boolean>(false);
    const dispatch = useContext(PlayerContextDispatch);

    useEffect(()=>{
        if (!props.styleLoaded) {
            const visibilityInterval = setInterval(() => {
                if (newWindow.current?.style.backgroundImage && newWindow.current?.style.backgroundImage.indexOf("newwindow.svg") > -1) {
                    clearInterval(visibilityInterval);
                }
                dispatch({
                    type: STYLESLOADED_ACTION
                })
            }, 200);
            return () => {
                clearInterval(visibilityInterval);
            }
        }
    },[]);

    useEffect(() => {

        const visibility = ()=>{
            setHiddenRef.current(isHidden());
        }

        document.addEventListener('visibilitychange', visibility);

        return () => {
            unmountedRef.current = true;
            document.removeEventListener('visibilitychange', visibility);
            if (refInterval.current)
                clearInterval(refInterval.current);
        }
    }, [])


    let changed:any[] = [station.playlist];
    if (hidden === false || hidden === true)
        changed.push(hidden);

    useEffect(() => {

        if (refInterval.current) {
            clearInterval(refInterval.current);
            refInterval.current = undefined;
        }


        if (!hidden && station.playlist) {
            const call = async () => {
                fetch(station.playlist).then(data => data.json()).then((data: {
                    current?: Song
                }) => {
                    if (!unmountedRef.current)
                        setSong(data.current || false)
                }).catch(e => {

                });
            }
            refInterval.current = setInterval(call, 15000);
            call();
        }

    }, changed)

    useEffect(()=>{

        let newCss = '';

        divs.current.forEach((element, key)=>{
            if (element &&  element.parentElement)
            {
                const divWidth = element.clientWidth;
                const parentWidth = element.parentElement.clientWidth;

                if (divWidth > parentWidth) {
                    const left = parentWidth - divWidth;

                    newCss += makeCss(left, uuid, key, Math.ceil(6 * (divWidth / parentWidth)));
                }
                else {
                    newCss += makeCss(0, uuid, key, Math.ceil(6 * (divWidth / parentWidth)));
                }
            }
        });

        setDivsCss(newCss);

    }, [JSON.stringify({song, station})])

    const innerSong = song ? <><strong>{song.interpret}</strong> - <span>{song.song}</span></> : <></>

    return <>
        {divsCss ? <style>{divsCss}</style> : false}
        <div className="radiacz-radio">
            <div className={`radiacz-running-text-${uuid}-0`} ref={el=>divs.current[0]=el}>{station.name}</div>

        </div>
        <div className="radiacz-song">
            <div className={`radiacz-running-text-${uuid}-1`} ref={el=>divs.current[1]=el}>{innerSong}</div>
        </div>
        <a ref={el=>newWindow.current=el} href={station.stationUrl} className={'radiacz-newwindow'} target={'_blank'}>{station.name}</a>
    </>
}

export const Station = () => {
    const {station, styleLoaded } = useContext(PlayerContext)
    return <>{station ? <StationItem key={station.stationId} station={station} styleLoaded={styleLoaded}/> : false}</>;
}